module.exports = __webpack_public_path__ + "static/wah-1f9a8c8b76f457e05bd23dcba5326849.png";